// extracted by mini-css-extract-plugin
export var overlay = "Menu-module--overlay--1bkBj";
export var active = "Menu-module--active--3vcQP";
export var wrapper = "Menu-module--wrapper--Q3DV6";
export var header = "Menu-module--header--2UCdX";
export var navigation = "Menu-module--navigation--3bRq0";
export var close = "Menu-module--close--1Z-7J";
export var iconLink = "Menu-module--iconLink--2mBAo";
export var iconBig = "Menu-module--iconBig--1qvEf";
export var icon = "Menu-module--icon--1PVLS";